module.exports = __webpack_public_path__ + "nc_static/media/landing-background.88238894.png";